import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly storage: StorageService
  ) {}

  get<T>(path: string): Observable<T> {
    return this.http.get<T>(this.url(path), {
      headers: this.headers(),
    });
  }

  post<T>(path: string, body: unknown): Observable<T> {
    return this.http.post<T>(this.url(path), body, {
      headers: this.headers(),
    });
  }

  put<T>(path: string, body: unknown): Observable<T> {
    return this.http.put<T>(this.url(path), body, {
      headers: this.headers(),
    });
  }

  delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(this.url(path), {
      headers: this.headers(),
    });
  }

  private url(path: string): string {
    return `${environment.apiBaseUrl}${path}`;
  }

  private headers(): HttpHeaders {
    const token = this.storage.getToken();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  }
}
